import React, {useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react-lite";
import { StateService } from "../services/StateService";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Cup from "../assets/cup.png";
import rankIconGrey from "../assets/grey-rank.png";
import rankIconBrown from "../assets/brown-rank.png";
import Trophy from "../assets/troph.png";
import LogoMark from "../assets/Logomark-White.svg";
import Paper from "@material-ui/core/Paper";
import Container from "react-bootstrap/Container";
import classNames from "classnames";
import Image from "react-image-enlarger";
import ConfettiExplosion from '@reonomy/react-confetti-explosion';
import TwitterIcon from '@material-ui/icons/Twitter';
import {WinnerTable} from "../components/WinnerTable";
import { WinnersStages } from "../components/WinnersStages";
import {Winner} from "../types";
import {AuthenticityNotice} from "../components/AuthenticityNotice";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    alignItems: "center",
    minHeight: "100vh",
    paddingTop: "65px",
    maxWidth: "1400px",
    margin: "0 auto",
  },
  grid: {
    display: "flex",
    justifyContent: "center",
  },
  cardSection: {
    marginBottom: "10%",
    flexGrow: 1,
    width: "100%",
  },

  media: {
    alignItems: "center",
    justifyContent: "center",
    display: "block",
    background: "transparent",
    borderRadius: 0,
    width: "100%",
    position: "relative",
  },
  artimg: {
    maxWidth: "100%",
    height: "auto",
    width: "auto",
    position: "relative",
    zIndex: 2,
    borderRadius: "30px",
  },
  img: {
    position: 'relative',
    width: '100%',
  },
  cup: {
    width: '285px',
    height: '285px',
    cursor: 'pointer',
  },
  ArtImg: {
    width: "100%",
    height: "100%",
    maxWidth: "321px",
    minWidth: "321px",
    maxHeight: "414px",
    minHeight: "414px",
    margin: "0 auto",
    borderRadius: "43px",
  },
  ArtImgSide: {
    width: "100%",
    height: "100%",
    // maxWidth: '269px',
    // maxHeight: '346px',
    // minWidth: '269px',
    // minHeight: '346px',
    maxWidth: "199px",
    minWidth: "199px",
    maxHeight: "261px",
    minHeight: "261px",
    margin: "0 auto",
    borderRadius: "43px",
  },
  MainTitle: {
    color: "#4e37de",
    fontSize: "150px",
    fontFamily: "Gilroy-Medium, sans-serif",
    fontWeight: 700,
    lineHeight: 0,
    position: "relative",
    zIndex: 1,
    marginTop: '95px',
  },

  rankingBox: {
    position: "relative",
  },

  outerRightSecondRing: {
    position: "absolute",
    left: "calc(50% - 9px)",
    height: "89px",
    width: "89px",
    backgroundImage:
      "linear-gradient(174deg, #98A0A0 0%, #98A0A0 5%, #98A0A0 15%, #1d1f23 50%, #1d1f23 100%)",
    borderRadius: "50%",
    bottom: "26px",
  },
  innerRightSecondRing: {
    position: "absolute",
    left: "calc(50% - 8px)",
    height: "86px",
    width: "86px",
    backgroundImage: "linear-gradient(0deg, #1d1f23, #1d1f23)",
    borderRadius: "50%",
    bottom: "28px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  outerLeftSecondRing: {
    position: "absolute",
    left: "calc(50% - 87px)",
    height: "89px",
    width: "89px",
    backgroundImage:
      "linear-gradient(325deg, #98A0A0 0%, #98A0A0 5%, #98A0A0 15%, #1d1f23 50%, #1d1f23 100%)",
    borderRadius: "50%",
    bottom: "24px",
  },
  innerLeftSecondRing: {
    position: "absolute",
    left: "calc(50% - 85px)",
    height: "86px",
    width: "86px",
    backgroundImage: "linear-gradient(0deg, #1d1f23, #1d1f23)",
    borderRadius: "50%",
    bottom: "25px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  outerRightFirstRing: {
    position: "absolute",
    left: "calc(50% - 8px)",
    height: "117px",
    width: "117px",
    backgroundImage:
      "linear-gradient(174deg, #EB9C38 0%, #EB9C38 5%, #EB9C38 15%, #1d1f23 50%, #1d1f23 100%)",
    borderRadius: "50%",
    bottom: "50px",
  },
  innerRightFirstRing: {
    position: "absolute",
    left: "calc(50% - 8px)",
    height: "116px",
    width: "116px",
    backgroundImage: "linear-gradient(0deg, #1d1f23, #1d1f23)",
    borderRadius: "50%",
    bottom: "50px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  outerLeftFirstRing: {
    position: "absolute",
    left: "calc(50% - 87px)",
    height: "116px",
    width: "116px",
    backgroundImage:
      "linear-gradient(325deg, #EB9C38 0%, #EB9C38 5%, #EB9C38 15%, #1d1f23 50%, #1d1f23 100%)",
    borderRadius: "50%",
    bottom: "49px",
  },
  innerLeftFirstRing: {
    position: "absolute",
    left: "calc(50% - 85px)",
    height: "114px",
    width: "114px",
    backgroundImage: "linear-gradient(0deg, #1d1f23, #1d1f23)",
    borderRadius: "50%",
    bottom: "50px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  outerRightThirdRing: {
    position: "absolute",
    left: "calc(50% - 9px)",
    height: "89px",
    width: "89px",
    backgroundImage:
      "linear-gradient(174deg, #B07555 0%, #B07555 5%, #B07555 15%, #1d1f23 50%, #1d1f23 100%)",
    borderRadius: "50%",
    bottom: "24px",
  },
  innerRightThirdRing: {
    position: "absolute",
    left: "calc(50% - 8px)",
    height: "86px",
    width: "86px",
    backgroundImage: "linear-gradient(0deg, #1d1f23, #1d1f23)",
    borderRadius: "50%",
    bottom: "26px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  artBox: {
    maxWidth: "271px",
    margin: "0 auto",
    position: "relative",
  },
  artBoxWrapper: {
    position: "relative"
  },
  outerLeftThirdRing: {
    position: "absolute",
    left: "calc(50% - 87px)",
    height: "89px",
    width: "89px",
    backgroundImage:
      "linear-gradient(325deg, #B07555 0%, #B07555 5%, #B07555 15%, #1d1f23 50%, #1d1f23 100%)",
    borderRadius: "50%",
    bottom: "24px",
  },
  innerLeftThirdRing: {
    position: "absolute",
    left: "calc(50% - 85px)",
    height: "86px",
    width: "86px",
    backgroundImage: "linear-gradient(0deg, #1d1f23, #1d1f23)",
    borderRadius: "50%",
    bottom: "25px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  rankTitle: {
    color: "#DDE7E7",
    fontSize: "14px",
    fontFamily: "Gilroy-Medium, sans-serif",
    fontWeight: 500,
  },
  rank: {
    color: "#DDE7E7",
    fontSize: "50px",
    lineHeight: "0.9",
    fontFamily: "Gilroy-Medium, sans-serif",
    fontWeight: 500,
  },
  Trophymg: {
    maxWidth: "100%",
    height: "auto",
    width: "auto",
    margin: "0 auto",
  },
  ArtNameLeftRight: {
    position: "absolute",
    bottom: "88px",
    left: "48px",
    color: "#FFFFFF",
    fontSize: "18px",
    fontWeight: 500,
    zIndex: 10,
    fontFamily: "Gilroy-Medium, sans-serif",
  },
  ArtNameMiddle: {
    position: "absolute",
    bottom: "33px",
    left: "131px",
    color: "#FFFFFF",
    fontSize: "18px",
    fontWeight: 500,
    fontFamily: "Gilroy-Medium, sans-serif",
  },
  UrlLinkLeftRight: {
    textAlign: "left",
    fontSize: "24px",
    display: "flex",
    marginTop: "17px",
  },
  UrlLinkMiddle: {
    textAlign: "left",
    fontSize: "24px",
    display: "flex",
    marginTop: "17px",
  },

  UrlLink: {
    color: "#f782ed",
    fontSize: "22px",
    display: "block",
    fontWeight: 500,
    fontFamily: "Gilroy-Medium, sans-serif",
    textDecoration: "none",
  },
  urlImage: {
    width: "43px",
    height: "43px",
  },

  LeftGradient: {
    position: "absolute",
    width: "521px",
    height: "359px",
    left: "0px",
    top: "0px",
    background:
      "linear-gradient(199.55deg, rgba(72, 46, 95, 0.225033) 40.83%, #503045 105.46%)",
    mixBlendMode: "normal",
    transform: "translate(-17%, -45%)",
    opacity: "0.9",
    filter: "blur(135.914px)",
    content: "",
    display: "block",
  },
  imageCaptionWrapper: {
    background: 
      "linear-gradient(180deg, rgba(29, 31, 35, 0.0001) 1.34%, #131518 90.33%)",
    height: '200px',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 2,
    borderRadius: '30px'
  },
  imageCaption: {
    fontSize: '19px',
    fontFamily: "Gilroy-Medium, sans-serif",
    display: 'inline-block',
    color: '#fff',
    marginTop: '9px',
    fontWeight: 500,
    marginRight: 'auto',
  },
  containers: {
    position: 'relative',
  },
  twitterIconLink: {
    zIndex: 2,
    width: '43px',
    height: '43px',
    borderRadius: '50%',
    display: 'inline-block',
    justifyContent: 'center',
    background: 'rgba(0, 0, 0, 0.7)',
    position: 'relative',
    marginLeft:  '10px'
  },
  twitterIcon: {
    fontSize: '30px',
    color: '#359bf0',
    cursor: 'pointer',
    margin: '0 auto',
    background: 'rgba(0, 0, 0, 0.7)',
    position: 'absolute',
    top: '50%',
    left: '50%',
    borderRadius: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30px',
    height: '30px'
  },
  rightLayout: {
    position: 'absolute',
    width: '433px',
    height: '461px',
    right: '0px',
    top: '53px',
    background: 'linear-gradient(190.81deg, #503045 40.52%, rgba(72, 46, 95, 0.225033) 86.44%)',
    mixBlendMode: 'normal',
    opacity: 0.9,
    filter: 'blur(135.914px)',
    transform: 'rotate(83deg)',
  },
  innerLay: {
    background: '#6E37FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
    width: '771px',
    height: '520px',
  },
  innerLay1: {
    background: '#3772FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
    width: '771px',
    height: '520px',
  },
  rightBottomLayout: {
    position: 'absolute',
    width: '231px',
    height: '256px',
    right: '-42px',
    bottom: '78px',
    background: 'linear-gradient(190.81deg, #503045 40.52%, rgba(72, 46, 95, 0.225033) 86.44%)',
    mixBlendMode: 'normal',
    opacity: 0.9,
    filter: 'blur(135.914px)',
  },
  BottominnerLay: {
    width: '522px',
    height: '349px',
    background: '#6E37FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
  },
  BottominnerLay1: {
    width: '522px',
    height: '349px',
    background: '#3772FF',
    mixBlendMode: 'normal',
    opacity: 0.12,
    filter: 'blur(135.914px)',
  }
}));

interface WinnerPageProps {
  state: StateService;
}

export const WinnerPage = observer((props: WinnerPageProps) => {
  const classes = useStyles();
  const [zoomedFirst, setZoomedFirst] = React.useState(false);
  const [zoomedSecond, setZoomedSecond] = React.useState(false);
  const [zoomedThird, setZoomedThird] = React.useState(false);
  const [isExploding, setIsExploding] = React.useState(false);
  const [isExplode, setIsExplode] = React.useState(false);
  
  const twitterText = "https://twitter.com/intent/tweet?text=I+just+created+NFT+AI+art%21+Check+it+out%3A+&url=https://colearn-paint.fetch.ai/&hashtags=fetchai,CoLearn,AI,NFT";
  let stageIndex = 0;
  let winners: Winner[] = props.state.winners.getWinners();

  const winningImages = props.state.images.getImages("voting3").sort((a, b) => b.votes - a.votes).slice(0, 3);

  useEffect(() => {
    const imageId = window.location.hash;
    if (winningImages.length === 3 && imageId !== '') {
      const titleElement = document.getElementById('winners_title');
      if (titleElement !== null) titleElement.scrollIntoView({ behavior: 'smooth' });
      if ("#" + winningImages[0].image_id === imageId) setZoomedFirst(true);
      else if ("#" + winningImages[1].image_id === imageId) setZoomedSecond(true);
      else if ("#" + winningImages[2].image_id === imageId) setZoomedThird(true);
    }
    const timeoutStart = setTimeout(() => {
      setIsExploding(true);
    }, 1000)
    const timeoutEnd = setTimeout(() => {
      setIsExploding(false);
    }, 3000)

    return () => {
      clearTimeout(timeoutStart);
      clearTimeout(timeoutEnd);
    }
    // eslint-disable-next-line
  }, []);


  const explodeConfetti = () => {
    setTimeout(() => {
      setIsExplode(true);
    }, 0)
    setTimeout(() => {
      setIsExplode(false);
    }, 4000);
  }

   

  // If opensea images are there, it is at least stage 1
  if (winningImages[1]?.openseaLink !== undefined &&
      winningImages[1]?.openseaLink !== null &&
      winningImages[1]?.openseaLink !== "") {
    stageIndex = 1;
  }

  // If rewards have been distributed, at least stage 2, completed
  if (winners.length > 0 && winners[0].reward) {
    stageIndex = 2;
  }

  // If the auction is cleared, set everything to complete
  if (props.state.bidStore.isCleared()) {
    stageIndex = 3;
  }

  return (
    <div className={classes.root}>
      {isExploding && (
        <ConfettiExplosion />
      )}
      {isExplode && (
        <ConfettiExplosion />
      )}
      <div className={classes.cardSection}>
        <Container>
          <Grid container className={classes.containers}>
            <div className={classes.LeftGradient}></div>
            <Grid
              item
              xs={12}
              className={classes.grid}
              style={{ marginBottom: "350px" }}
            >
              <Paper elevation={0} className={classes.media}>
                <div className="likeImg">
                  <div className={classes.img}>
                    <img onClick={explodeConfetti} className={classes.cup} src={Cup} alt="Like" />
                  </div>
                  <Typography
                    id="winners_title"
                    className={classes.MainTitle}
                    variant="h5"
                    component="h2"
                  >
                    WINNERS
                  </Typography>
                </div>
              </Paper>
            </Grid>
            <Grid
              item
              xs={4}
              className={classes.grid}
              style={{ flexDirection: "column" }}
            >
              <Paper elevation={0} className={classes.media}>
                <div className={classes.rankingBox}>
                  <div
                    className={classNames(classes.outerLeftSecondRing)}
                  ></div>
                  <div className={classNames(classes.innerLeftSecondRing)}>
                    <span className={classes.rankTitle}>Rank</span>
                    <span className={classes.rank}>2</span>
                  </div>
                  <div
                    className={classNames(classes.outerRightSecondRing)}
                  ></div>
                  <div className={classNames(classes.innerRightSecondRing)}>
                    <img
                      className={classes.Trophymg}
                      src={rankIconGrey}
                      alt="Trophy"
                    />
                  </div>
                </div>
                <div className={classNames(classes.artBox)}>
                  <div className={classes.artBoxWrapper}>
                    <Image
                      overlayColor="rgba(0, 0, 0, 0.5)"
                      className={classes.artimg}
                      zoomed={zoomedSecond}
                      src={winningImages[1]?.src}
                      onClick={() => setZoomedSecond(true)}
                      onRequestClose={() => setZoomedSecond(false)}
                    />
                  </div>
                  <Typography
                    className={classes.UrlLinkLeftRight}
                    component="h2"
                  >
                    <p className={classes.imageCaption}>{winningImages[1]?.image_id}</p>
                    {winningImages[1]?.openseaLink && (
                      <Link
                        className={classes.UrlLink}
                        href={winningImages[1]?.openseaLink}
                        target="_blank"
                      >
                        <img className={classes.urlImage} alt="logo" src={LogoMark} />
                      </Link>
                    )}
                    <a className={classes.twitterIconLink} href={twitterText} target="_blank" rel="noreferrer"><TwitterIcon className={classes.twitterIcon} /></a>
                  </Typography>
                </div>
              </Paper>
            </Grid>
            <Grid
              item
              xs={4}
              className={classes.grid}
              style={{ flexDirection: "column" }}
            >
              <Paper elevation={0} className={classes.media}>
                <div className={classes.rankingBox}>
                  <div className={classNames(classes.outerLeftFirstRing)}></div>
                  <div className={classNames(classes.innerLeftFirstRing)}>
                    <span className={classes.rankTitle}>Rank</span>
                    <span className={classes.rank}>1</span>
                  </div>
                  <div
                    className={classNames(classes.outerRightFirstRing)}
                  ></div>
                  <div className={classNames(classes.innerRightFirstRing)}>
                    <img
                      className={classes.Trophymg}
                      src={Trophy}
                      alt="Trophy"
                    />
                  </div>
                </div>
                <div className={classes.artBoxWrapper}>
                  <Image
                      overlayColor="rgba(0, 0, 0, 0.5)"
                      className={classes.artimg}
                      zoomed={zoomedFirst}
                      src={winningImages[0]?.src}
                      onClick={() => setZoomedFirst(true)}
                      onRequestClose={() => setZoomedFirst(false)}
                    />
                </div>
                <Typography className={classes.UrlLinkMiddle} component="h2">
                <p className={classes.imageCaption}>{winningImages[0]?.image_id}</p>
                  {winningImages[0]?.openseaLink && (
                    <Link
                      className={classes.UrlLink}
                      href={winningImages[0]?.openseaLink}
                      target="_blank"
                    >
                      <img className={classes.urlImage} alt="logo" src={LogoMark} />
                    </Link>
                  )}
                  <a className={classes.twitterIconLink} href={twitterText} target="_blank" rel="noreferrer"><TwitterIcon className={classes.twitterIcon} /></a>
                </Typography>
              </Paper>
            </Grid>
            <Grid
              item
              xs={4}
              className={classes.grid}
              style={{ flexDirection: "column" }}
            >
              <Paper elevation={0} className={classes.media}>
                <div className={classes.rankingBox}>
                  <div className={classNames(classes.outerLeftThirdRing)}></div>
                  <div className={classNames(classes.innerLeftThirdRing)}>
                    <span className={classes.rankTitle}>Rank</span>
                    <span className={classes.rank}>3</span>
                  </div>
                  <div
                    className={classNames(classes.outerRightThirdRing)}
                  ></div>
                  <div className={classNames(classes.innerRightThirdRing)}>
                    <img
                      className={classes.Trophymg}
                      src={rankIconBrown}
                      alt="Trophy"
                    />
                  </div>
                </div>
                <div className={classNames(classes.artBox, classes.artBoxWrapper)}>
                  <div className={classes.artBoxWrapper}>
                    <Image
                      overlayColor="rgba(0, 0, 0, 0.5)"
                      className={classes.artimg}
                      zoomed={zoomedThird}
                      src={winningImages[2]?.src}
                      onClick={() => setZoomedThird(true)}
                      onRequestClose={() => setZoomedThird(false)}
                    />
                  </div>
                  <Typography className={classes.UrlLinkLeftRight} component="h2">
                    <p className={classes.imageCaption}>{winningImages[2]?.image_id}</p>
                    {winningImages[2]?.openseaLink && (
                      <Link
                        className={classes.UrlLink}
                        href={winningImages[2]?.openseaLink}
                        target="_blank">
                        <img className={classes.urlImage} alt="logo" src={LogoMark} />
                      </Link>
                    )}
                    <a className={classes.twitterIconLink} href={twitterText} target="_blank" rel="noreferrer"><TwitterIcon className={classes.twitterIcon} /></a>
                  </Typography>
                </div>
              </Paper>
            </Grid>
            <div className={classes.rightLayout}>
            <div className={classes.innerLay}>
            </div>
            <div className={classes.innerLay1}>
            </div>
          </div>
            <div className={classes.rightBottomLayout}>
            <div className={classes.BottominnerLay}></div>
            <div className={classes.BottominnerLay1}>
            </div>
          </div>
          </Grid>
        </Container>
      </div>

      <AuthenticityNotice/>

      <WinnersStages index={stageIndex}/>
      <WinnerTable
          state={props.state}
      />
    </div>
  );
});
